import { render, staticRenderFns } from "./board_detail.vue?vue&type=template&id=28e77060&scoped=true&"
import script from "./board_detail.vue?vue&type=script&lang=js&"
export * from "./board_detail.vue?vue&type=script&lang=js&"
import style0 from "./board_detail.vue?vue&type=style&index=0&id=28e77060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e77060",
  null
  
)

export default component.exports